const { gql } = require('@apollo/client');
const { useQuery } = require('./apollo');

const QUERY = gql`
  query {
    config {
      survey { baseUrl }
      matomo { baseUrl }
    }
  }
`;

function useConfig() {
  const { data, loading } = useQuery(QUERY, { networkPolicy: 'cache-first' });

  return { config: data?.config, loading };
}

export default useConfig;
